import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { WorkflowLayout } from 'Components/ComponentLibrary/Organisms/WorkflowLayout/WorkflowLayout';
import { FDContentContainer } from '@facet-wealth/design';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { AccountOpeningV2OpeningTakingTooLongStepLayout } from './layout';
import { metaOverrideSet } from './metaOverrideSet';

export const AccountOpeningV2OpeningTakingTooLongStepTemplate = ({ resource }) => {
  return (
    <WorkflowLayout appearance="elevated">
      <FDContentContainer maxWidth="sm">
        <MetaResourceRenderer
          metaOverrideSet={metaOverrideSet}
          layout={AccountOpeningV2OpeningTakingTooLongStepLayout}
          resource={resource}
        />
      </FDContentContainer>
    </WorkflowLayout>
  );
};

AccountOpeningV2OpeningTakingTooLongStepTemplate.defaultProps = {
};

AccountOpeningV2OpeningTakingTooLongStepTemplate.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
